import { ArrowDown16, ArrowUp16, Bus16, Eye16, Route16, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { EMapService } from 'shared/types/map';

import * as styles from './MapServices.css';
import { MapRows } from '../MapRows';

const MAP_SERVICES = {
  [EMapService.FutureInfrastructure]: {
    text: 'Развитие инфраструктуры',
    IconComponent: Eye16,
  },
  [EMapService.TransportAccessibility]: {
    text: 'Транспортная доступность',
    IconComponent: Bus16,
  },
  [EMapService.Routes]: {
    text: 'Маршруты',
    IconComponent: Route16,
  },
};

export interface IMapServicesProps {
  onServiceClick: (service: EMapService) => void;
  serviceTypes: EMapService[];
}

export const MapServices: React.FC<IMapServicesProps> = ({ onServiceClick, serviceTypes }) => {
  const [open, setOpen] = React.useState(true);

  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = contentRef.current?.scrollHeight + 'px';
    }
  }, [serviceTypes]);

  const handleClick = React.useCallback(() => {
    if (!contentRef.current) {
      return;
    }

    setOpen(!open);

    if (!open) {
      contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
    } else {
      contentRef.current.style.maxHeight = '0';
    }
  }, [open]);

  const items = serviceTypes.map(serviceType => ({
    id: serviceType,
    ...MAP_SERVICES[serviceType],
  }));

  return (
    <div className={styles['container']}>
      <div className={styles['title-row']} onClick={handleClick}>
        <UIText1 fontWeight="bold">Сервисы</UIText1>
        <div className={styles['chevron-icon']}>{open ? <ArrowDown16 /> : <ArrowUp16 />}</div>
      </div>

      <div ref={contentRef} className={styles['content']} data-testid="MapServicesContent">
        <MapRows items={items} onRowClick={onServiceClick} />
      </div>
    </div>
  );
};
